import { getOutboundTransportTemplate } from "@/api/template";
import FileDownloader from "@/components/FileDownloader/FileDownloader";
import FileUploader from "@/components/FileUploader/FileUploader";
import HelpButton from "@/components/HelpButton/HelpButton";
import PageButtonGroup from "@/components/PageButtonGroup/PageButtonGroup";
import useTranslation from "@/hooks/useTranslation";
import { DownloadOutlined } from "@ant-design/icons";
import { transportDetailUploadColumns, transportUploadFilters } from "../constants";
import "../Transport.scss";

export default function OutboundTransportButtonGroup() {
  const translation = useTranslation();

  return (
    <>
      {" "}
      <HelpButton
        type="text"
        url="https://help.root-sustainability.com/en/articles/9898985-outbound-transport"
      />
      <PageButtonGroup>
        <FileUploader
          uploadType={"outbound_transport"}
          buttonText={translation.transport.upload}
          uploadDataTableProps={{
            columns: transportDetailUploadColumns,
            rowKey: "key",
            availableFilters: transportUploadFilters,
          }}
          templateUrlFn={getOutboundTransportTemplate}
        />
        <FileDownloader
          fileOutputName="template-outbound-transport.xlsx"
          fileUrlFn={getOutboundTransportTemplate}
          buttonText="Template"
          icon={<DownloadOutlined />}
        />
      </PageButtonGroup>
    </>
  );
}
